import { render, staticRenderFns } from "./zgy-login.vue?vue&type=template&id=d4a06316&scoped=true&"
import script from "./zgy-login.vue?vue&type=script&lang=js&"
export * from "./zgy-login.vue?vue&type=script&lang=js&"
import style0 from "./zgy-login.vue?vue&type=style&index=0&id=d4a06316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a06316",
  null
  
)

export default component.exports